function setCookie(productInfo,cvalue,exdays){
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = productInfo + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(productInfo) {
  let name = productInfo + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

document.addEventListener('DOMContentLoaded', function() {
  const days7 = new Date();
  days7.setDate(days7.getDate() + 7); // Add 7 day to today
  const days7Date = days7.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  
  document.getElementById('event_date').setAttribute('min', days7Date);
});

jQuery(document).on('click','.addToDate',function(){
  jQuery(this).parent().parent().addClass('doAxtions');
  var janu = jQuery('.doAxtions');
  loadCookie(janu);
});

function loadCookie(janu){
  var pTitle = janu.find('a.cart-item__name').text(),
      pPrice = janu.find('a.cart-item__name').next('div.product-option').text(),
      field = '',
      itemK = janu.find('.itemKey').text();
  janu.find('dl').find('.product-option').each(function(){
    field += jQuery(this).text() + '<br/>';
  });
  
  var info = 'Title:' + pTitle + '__Price:' + pPrice + '__Fields:' + field + 'itemKey:' + itemK;
  let cleanedString = info.trim();
  
  cleanedString = cleanedString.replace(/\s*<br\s*\/?>\s*/g, '<br/>');
  cleanedString = cleanedString.replace(/\s+/g, ' ');
  cleanedString = cleanedString.replace(/__\s+/g, '__ ').replace(/\s+__/g, ' __');
  cleanedString = cleanedString.replace(/\s+<br\/>/g, '<br/>').replace(/<br\/>\s+/g, '<br/>');
  cleanedString = cleanedString.trim();
  
  setCookie("productDetails", '', 365);
  setCookie("productDetails", cleanedString, 365);
  //janu.removeClass('doAxtions');

  var string = getCookie('productDetails');

  var titleMatch = string.match(/Title:([^_]+)/);
  var priceMatch = string.match(/Price:\s*([^_]+)/);
  var fieldsMatch = string.match(/Fields:\s*([^<]+)/);

  var title = titleMatch ? titleMatch[1].trim() : '';
  var price = priceMatch ? priceMatch[1].trim() : '';
  price = price.replace('Rs.','');
  var fields = fieldsMatch ? string.split('Fields:')[1].split('<br/>')[0].trim() : '';
  var remainingFields = string.split('Fields:')[1].replace(fields, '').trim();
  remainingFields = remainingFields.split('itemKey:')[0].replace(fields, '').trim();
  myItemKey = string.split('itemKey:')[1].replace(fields, '').trim();

  remainingFields = remainingFields.replace(/<br\s*\/?>/g, '\n');
  
  document.getElementById('event_id').value = '';
  document.getElementById('event_date').value = '';
  document.getElementById('event_time').value = '12:00';
  document.getElementById('event_title').value = `${title}`;
  document.getElementById('event_gift').value = '';
  document.getElementById('event_gift_price').value = `${price}`;
  document.getElementById('gift_status').value = 'allocate';
  document.getElementById('product_info').value = `${fields}${remainingFields}`;
  document.getElementById('event_info').value = '';

  jQuery('#gift-modal').modal('show');
}

jQuery(document).on('click','#event-form #submitFOrm',function(e){
  e.preventDefault();
  var formData = $(this).closest('form').serialize();
  var theDate = $('#event_date').val();
  
  fetch('//technology-architects.com/tasweer-modules/calendarModule/addEvent.php?date=' + theDate, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      updateInCart(data.event_id);
      setCookie('productDetails', null, -1);
    } else {
      console.log('⚠️ Failed to add event: ' + data.message);
    }
  })
  .catch(error => console.log('An error occurred: ' + error));
});

function checkGiftExist(){
  if ($('dt:contains("Gift ID:")').length > 0) {
    console.log("Gift ID exists");
  } else {
    console.log("Gift ID does not exist");
  }
}

function updateInCart(gfID) {
  var evDate = jQuery('#event_date').val();
  var evTime = jQuery('#event_time').val();
  var evName = jQuery('#event_gift').val();
  var evStat = jQuery('#gift_status').val();
  var evDesc = jQuery('#event_info').val();

  var combinedDateTime = new Date(evDate + 'T' + evTime);
  var options = {
    hour: '2-digit', minute: '2-digit', hour12: true,
    month: 'short', day: '2-digit', year: 'numeric'
  };
  var formatted = combinedDateTime.toLocaleString('en-US', options);

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const itemToUpdate = cart.items.find(item => item.key === myItemKey);
      if (!itemToUpdate) return console.error('Item not found in cart');

      const updatedProperties = {
        ...itemToUpdate.properties,
        'Gift ID': gfID,
        'Gift Date & Time': formatted,
        'Gift Name': evName,
        'Gift Status': evStat,
        'Gift Instructions': evDesc
      };

      updateCartItem(itemToUpdate.key, itemToUpdate.variant_id, itemToUpdate.quantity, updatedProperties);
    })
    .catch(err => console.error('Failed to fetch cart:', err));

  function updateCartItem(itemKey, variantId, quantity, properties) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    })
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity, properties: properties })
      });
    })
    .then(res => res.json())
    .then(data => {
      console.log('✅ Cart updated:', data);
      
      window.location = '/cart';
    })
    .catch(err => console.error('❌ Error updating cart item:', err));
  }
}

